module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"purchased_at":"{0} 購買","best_review_reward":"入選優質評價，最高可獲{0}！"}}')
  delete Component.options._Ctor
}
